import { useContext } from 'react';
import { UserContext } from 'context';
import i18n from 'i18n-js';

const VehiclesGroupsLabel = ({ plural, type = 'DIRECT' } = {}) => {
  const { orgType } = useContext(UserContext);
  const isOwner = orgType === 'msOwnerOrg';
  const isDirect = type === 'DIRECT';
  if (isDirect) {
    const fleets = `vehicle_groups.service_area${plural ? 's' : ''}`;
    const vehicle_group = `vehicle_groups.vehicle_group${plural ? 's' : ''}`;
    return isOwner ? i18n.t(fleets) : i18n.t(vehicle_group);
  } else {
    const fleets = 'users.fleets_from_user_groups';
    const vehicle_group = 'users.service_groups_from_users';
    return isOwner ? i18n.t(fleets) : i18n.t(vehicle_group);
  }
};

export default VehiclesGroupsLabel;
